import { RoundTo } from "@pdfking/math"
import { RecordQ } from "@pdfking/structs"
import { DeleteDuplicates, ToArray, Values } from "@pdfking/tfunc"

import type { QuantitySpec } from "#public"

import { Convert } from "./Convert"

type QuantityFormatOptions = {
  unit?: string
  decimals?: number
}

const simplify = <T>(values: T[]): T[] => {
  if (values.length === 1) return values
  const unique = [...DeleteDuplicates(values)]
  return unique.length === 1 ? unique : values
}

export const QuantityToString = <T extends number>(
  values: T | T[] | Record<any, T>,
  spec?: QuantitySpec<T>,
  { unit = spec?.input_unit ?? "", decimals = 2 }: QuantityFormatOptions = {}
): string => {
  const arr = simplify(RecordQ(values) ? Values(values) : ToArray(values))
  const format = (v: T) => `${RoundTo(v, decimals)}`
  // no spec → plain number(s), no conversion or unit suffix
  if (!spec?.standard_unit) return arr.map(format).join("x")
  return (
    arr.map(v => format(Convert(v, spec, spec.standard_unit, unit) as T)).join("x") + " " + unit
  )
}
